import { render, staticRenderFns } from "./LISSpecimenSticker.vue?vue&type=template&id=9e5ffee6&scoped=true"
import script from "./LISSpecimenSticker.vue?vue&type=script&lang=js"
export * from "./LISSpecimenSticker.vue?vue&type=script&lang=js"
import style0 from "./LISSpecimenSticker.vue?vue&type=style&index=0&id=9e5ffee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5ffee6",
  null
  
)

export default component.exports